/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SupervisorIndexRouteImport } from './routes/supervisor/index'
import { Route as ProducerIndexRouteImport } from './routes/producer/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ActorIndexRouteImport } from './routes/actor/index'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AdminOrgsRouteImport } from './routes/admin/orgs'
import { Route as AdminHealthRouteImport } from './routes/admin/health'
import { Route as AdminFeatureFlagsRouteImport } from './routes/admin/feature-flags'
import { Route as AdminFailedJobsRouteImport } from './routes/admin/failed-jobs'
import { Route as AdminClientErrorsRouteImport } from './routes/admin/client-errors'
import { Route as AdminAuditLogRouteImport } from './routes/admin/audit-log'
import { Route as AdminArchivalRouteImport } from './routes/admin/archival'
import { Route as AccountTaxRouteImport } from './routes/account/tax'
import { Route as AccountSecurityRouteImport } from './routes/account/security'
import { Route as AccountProfileRouteImport } from './routes/account/profile'
import { Route as AccountPaymentRouteImport } from './routes/account/payment'
import { Route as AccountNotificationsRouteImport } from './routes/account/notifications'
import { Route as AccountEarningsRouteImport } from './routes/account/earnings'
import { Route as AccountDevicesRouteImport } from './routes/account/devices'
import { Route as AccountDataExportRouteImport } from './routes/account/data-export'
import { Route as AcceptInviteTokenRouteImport } from './routes/accept-invite.$token'
import { Route as ProducerProjectsNewRouteImport } from './routes/producer/projects.new'
import { Route as SupervisorProjectsProjectIdIndexRouteImport } from './routes/supervisor/projects.$projectId/index'
import { Route as ProducerProjectsProjectIdIndexRouteImport } from './routes/producer/projects.$projectId/index'
import { Route as ActorProjectsProjectIdIndexRouteImport } from './routes/actor/projects.$projectId/index'
import { Route as SupervisorProjectsProjectIdTakesRouteImport } from './routes/supervisor/projects.$projectId/takes'
import { Route as SupervisorProjectsProjectIdStemsRouteImport } from './routes/supervisor/projects.$projectId/stems'
import { Route as ProducerProjectsProjectIdTakesRouteImport } from './routes/producer/projects.$projectId/takes'
import { Route as ProducerProjectsProjectIdSetupRouteImport } from './routes/producer/projects.$projectId/setup'
import { Route as ProducerProjectsProjectIdScriptBookRouteImport } from './routes/producer/projects.$projectId/script-book'
import { Route as ProducerProjectsProjectIdFinancialsRouteImport } from './routes/producer/projects.$projectId/financials'
import { Route as ProducerProjectsProjectIdCharactersRouteImport } from './routes/producer/projects.$projectId/characters'
import { Route as ActorProjectsProjectIdUploadRouteImport } from './routes/actor/projects.$projectId/upload'
import { Route as ActorProjectsProjectIdScriptReviewRouteImport } from './routes/actor/projects.$projectId/script-review'
import { Route as ActorProjectsProjectIdRecordRouteImport } from './routes/actor/projects.$projectId/record'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupervisorIndexRoute = SupervisorIndexRouteImport.update({
  id: '/supervisor/',
  path: '/supervisor/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProducerIndexRoute = ProducerIndexRouteImport.update({
  id: '/producer/',
  path: '/producer/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActorIndexRoute = ActorIndexRouteImport.update({
  id: '/actor/',
  path: '/actor/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrgsRoute = AdminOrgsRouteImport.update({
  id: '/admin/orgs',
  path: '/admin/orgs',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/admin/health',
  path: '/admin/health',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFeatureFlagsRoute = AdminFeatureFlagsRouteImport.update({
  id: '/admin/feature-flags',
  path: '/admin/feature-flags',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFailedJobsRoute = AdminFailedJobsRouteImport.update({
  id: '/admin/failed-jobs',
  path: '/admin/failed-jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminClientErrorsRoute = AdminClientErrorsRouteImport.update({
  id: '/admin/client-errors',
  path: '/admin/client-errors',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
  id: '/admin/audit-log',
  path: '/admin/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminArchivalRoute = AdminArchivalRouteImport.update({
  id: '/admin/archival',
  path: '/admin/archival',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountTaxRoute = AccountTaxRouteImport.update({
  id: '/account/tax',
  path: '/account/tax',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSecurityRoute = AccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountProfileRoute = AccountProfileRouteImport.update({
  id: '/account/profile',
  path: '/account/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountPaymentRoute = AccountPaymentRouteImport.update({
  id: '/account/payment',
  path: '/account/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountNotificationsRoute = AccountNotificationsRouteImport.update({
  id: '/account/notifications',
  path: '/account/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountEarningsRoute = AccountEarningsRouteImport.update({
  id: '/account/earnings',
  path: '/account/earnings',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDevicesRoute = AccountDevicesRouteImport.update({
  id: '/account/devices',
  path: '/account/devices',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDataExportRoute = AccountDataExportRouteImport.update({
  id: '/account/data-export',
  path: '/account/data-export',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteTokenRoute = AcceptInviteTokenRouteImport.update({
  id: '/accept-invite/$token',
  path: '/accept-invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProducerProjectsNewRoute = ProducerProjectsNewRouteImport.update({
  id: '/producer/projects/new',
  path: '/producer/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SupervisorProjectsProjectIdIndexRoute =
  SupervisorProjectsProjectIdIndexRouteImport.update({
    id: '/supervisor/projects/$projectId/',
    path: '/supervisor/projects/$projectId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProducerProjectsProjectIdIndexRoute =
  ProducerProjectsProjectIdIndexRouteImport.update({
    id: '/producer/projects/$projectId/',
    path: '/producer/projects/$projectId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ActorProjectsProjectIdIndexRoute =
  ActorProjectsProjectIdIndexRouteImport.update({
    id: '/actor/projects/$projectId/',
    path: '/actor/projects/$projectId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupervisorProjectsProjectIdTakesRoute =
  SupervisorProjectsProjectIdTakesRouteImport.update({
    id: '/supervisor/projects/$projectId/takes',
    path: '/supervisor/projects/$projectId/takes',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupervisorProjectsProjectIdStemsRoute =
  SupervisorProjectsProjectIdStemsRouteImport.update({
    id: '/supervisor/projects/$projectId/stems',
    path: '/supervisor/projects/$projectId/stems',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProducerProjectsProjectIdTakesRoute =
  ProducerProjectsProjectIdTakesRouteImport.update({
    id: '/producer/projects/$projectId/takes',
    path: '/producer/projects/$projectId/takes',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProducerProjectsProjectIdSetupRoute =
  ProducerProjectsProjectIdSetupRouteImport.update({
    id: '/producer/projects/$projectId/setup',
    path: '/producer/projects/$projectId/setup',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProducerProjectsProjectIdScriptBookRoute =
  ProducerProjectsProjectIdScriptBookRouteImport.update({
    id: '/producer/projects/$projectId/script-book',
    path: '/producer/projects/$projectId/script-book',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProducerProjectsProjectIdFinancialsRoute =
  ProducerProjectsProjectIdFinancialsRouteImport.update({
    id: '/producer/projects/$projectId/financials',
    path: '/producer/projects/$projectId/financials',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProducerProjectsProjectIdCharactersRoute =
  ProducerProjectsProjectIdCharactersRouteImport.update({
    id: '/producer/projects/$projectId/characters',
    path: '/producer/projects/$projectId/characters',
    getParentRoute: () => rootRouteImport,
  } as any)
const ActorProjectsProjectIdUploadRoute =
  ActorProjectsProjectIdUploadRouteImport.update({
    id: '/actor/projects/$projectId/upload',
    path: '/actor/projects/$projectId/upload',
    getParentRoute: () => rootRouteImport,
  } as any)
const ActorProjectsProjectIdScriptReviewRoute =
  ActorProjectsProjectIdScriptReviewRouteImport.update({
    id: '/actor/projects/$projectId/script-review',
    path: '/actor/projects/$projectId/script-review',
    getParentRoute: () => rootRouteImport,
  } as any)
const ActorProjectsProjectIdRecordRoute =
  ActorProjectsProjectIdRecordRouteImport.update({
    id: '/actor/projects/$projectId/record',
    path: '/actor/projects/$projectId/record',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/accept-invite/$token': typeof AcceptInviteTokenRoute
  '/account/data-export': typeof AccountDataExportRoute
  '/account/devices': typeof AccountDevicesRoute
  '/account/earnings': typeof AccountEarningsRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/payment': typeof AccountPaymentRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/security': typeof AccountSecurityRoute
  '/account/tax': typeof AccountTaxRoute
  '/admin/archival': typeof AdminArchivalRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/client-errors': typeof AdminClientErrorsRoute
  '/admin/failed-jobs': typeof AdminFailedJobsRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/account/': typeof AccountIndexRoute
  '/actor/': typeof ActorIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/producer/': typeof ProducerIndexRoute
  '/supervisor/': typeof SupervisorIndexRoute
  '/producer/projects/new': typeof ProducerProjectsNewRoute
  '/actor/projects/$projectId/record': typeof ActorProjectsProjectIdRecordRoute
  '/actor/projects/$projectId/script-review': typeof ActorProjectsProjectIdScriptReviewRoute
  '/actor/projects/$projectId/upload': typeof ActorProjectsProjectIdUploadRoute
  '/producer/projects/$projectId/characters': typeof ProducerProjectsProjectIdCharactersRoute
  '/producer/projects/$projectId/financials': typeof ProducerProjectsProjectIdFinancialsRoute
  '/producer/projects/$projectId/script-book': typeof ProducerProjectsProjectIdScriptBookRoute
  '/producer/projects/$projectId/setup': typeof ProducerProjectsProjectIdSetupRoute
  '/producer/projects/$projectId/takes': typeof ProducerProjectsProjectIdTakesRoute
  '/supervisor/projects/$projectId/stems': typeof SupervisorProjectsProjectIdStemsRoute
  '/supervisor/projects/$projectId/takes': typeof SupervisorProjectsProjectIdTakesRoute
  '/actor/projects/$projectId/': typeof ActorProjectsProjectIdIndexRoute
  '/producer/projects/$projectId/': typeof ProducerProjectsProjectIdIndexRoute
  '/supervisor/projects/$projectId/': typeof SupervisorProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/accept-invite/$token': typeof AcceptInviteTokenRoute
  '/account/data-export': typeof AccountDataExportRoute
  '/account/devices': typeof AccountDevicesRoute
  '/account/earnings': typeof AccountEarningsRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/payment': typeof AccountPaymentRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/security': typeof AccountSecurityRoute
  '/account/tax': typeof AccountTaxRoute
  '/admin/archival': typeof AdminArchivalRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/client-errors': typeof AdminClientErrorsRoute
  '/admin/failed-jobs': typeof AdminFailedJobsRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/account': typeof AccountIndexRoute
  '/actor': typeof ActorIndexRoute
  '/admin': typeof AdminIndexRoute
  '/producer': typeof ProducerIndexRoute
  '/supervisor': typeof SupervisorIndexRoute
  '/producer/projects/new': typeof ProducerProjectsNewRoute
  '/actor/projects/$projectId/record': typeof ActorProjectsProjectIdRecordRoute
  '/actor/projects/$projectId/script-review': typeof ActorProjectsProjectIdScriptReviewRoute
  '/actor/projects/$projectId/upload': typeof ActorProjectsProjectIdUploadRoute
  '/producer/projects/$projectId/characters': typeof ProducerProjectsProjectIdCharactersRoute
  '/producer/projects/$projectId/financials': typeof ProducerProjectsProjectIdFinancialsRoute
  '/producer/projects/$projectId/script-book': typeof ProducerProjectsProjectIdScriptBookRoute
  '/producer/projects/$projectId/setup': typeof ProducerProjectsProjectIdSetupRoute
  '/producer/projects/$projectId/takes': typeof ProducerProjectsProjectIdTakesRoute
  '/supervisor/projects/$projectId/stems': typeof SupervisorProjectsProjectIdStemsRoute
  '/supervisor/projects/$projectId/takes': typeof SupervisorProjectsProjectIdTakesRoute
  '/actor/projects/$projectId': typeof ActorProjectsProjectIdIndexRoute
  '/producer/projects/$projectId': typeof ProducerProjectsProjectIdIndexRoute
  '/supervisor/projects/$projectId': typeof SupervisorProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/accept-invite/$token': typeof AcceptInviteTokenRoute
  '/account/data-export': typeof AccountDataExportRoute
  '/account/devices': typeof AccountDevicesRoute
  '/account/earnings': typeof AccountEarningsRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/payment': typeof AccountPaymentRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/security': typeof AccountSecurityRoute
  '/account/tax': typeof AccountTaxRoute
  '/admin/archival': typeof AdminArchivalRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/client-errors': typeof AdminClientErrorsRoute
  '/admin/failed-jobs': typeof AdminFailedJobsRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/account/': typeof AccountIndexRoute
  '/actor/': typeof ActorIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/producer/': typeof ProducerIndexRoute
  '/supervisor/': typeof SupervisorIndexRoute
  '/producer/projects/new': typeof ProducerProjectsNewRoute
  '/actor/projects/$projectId/record': typeof ActorProjectsProjectIdRecordRoute
  '/actor/projects/$projectId/script-review': typeof ActorProjectsProjectIdScriptReviewRoute
  '/actor/projects/$projectId/upload': typeof ActorProjectsProjectIdUploadRoute
  '/producer/projects/$projectId/characters': typeof ProducerProjectsProjectIdCharactersRoute
  '/producer/projects/$projectId/financials': typeof ProducerProjectsProjectIdFinancialsRoute
  '/producer/projects/$projectId/script-book': typeof ProducerProjectsProjectIdScriptBookRoute
  '/producer/projects/$projectId/setup': typeof ProducerProjectsProjectIdSetupRoute
  '/producer/projects/$projectId/takes': typeof ProducerProjectsProjectIdTakesRoute
  '/supervisor/projects/$projectId/stems': typeof SupervisorProjectsProjectIdStemsRoute
  '/supervisor/projects/$projectId/takes': typeof SupervisorProjectsProjectIdTakesRoute
  '/actor/projects/$projectId/': typeof ActorProjectsProjectIdIndexRoute
  '/producer/projects/$projectId/': typeof ProducerProjectsProjectIdIndexRoute
  '/supervisor/projects/$projectId/': typeof SupervisorProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/accept-invite/$token'
    | '/account/data-export'
    | '/account/devices'
    | '/account/earnings'
    | '/account/notifications'
    | '/account/payment'
    | '/account/profile'
    | '/account/security'
    | '/account/tax'
    | '/admin/archival'
    | '/admin/audit-log'
    | '/admin/client-errors'
    | '/admin/failed-jobs'
    | '/admin/feature-flags'
    | '/admin/health'
    | '/admin/orgs'
    | '/auth/callback'
    | '/account/'
    | '/actor/'
    | '/admin/'
    | '/producer/'
    | '/supervisor/'
    | '/producer/projects/new'
    | '/actor/projects/$projectId/record'
    | '/actor/projects/$projectId/script-review'
    | '/actor/projects/$projectId/upload'
    | '/producer/projects/$projectId/characters'
    | '/producer/projects/$projectId/financials'
    | '/producer/projects/$projectId/script-book'
    | '/producer/projects/$projectId/setup'
    | '/producer/projects/$projectId/takes'
    | '/supervisor/projects/$projectId/stems'
    | '/supervisor/projects/$projectId/takes'
    | '/actor/projects/$projectId/'
    | '/producer/projects/$projectId/'
    | '/supervisor/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/accept-invite/$token'
    | '/account/data-export'
    | '/account/devices'
    | '/account/earnings'
    | '/account/notifications'
    | '/account/payment'
    | '/account/profile'
    | '/account/security'
    | '/account/tax'
    | '/admin/archival'
    | '/admin/audit-log'
    | '/admin/client-errors'
    | '/admin/failed-jobs'
    | '/admin/feature-flags'
    | '/admin/health'
    | '/admin/orgs'
    | '/auth/callback'
    | '/account'
    | '/actor'
    | '/admin'
    | '/producer'
    | '/supervisor'
    | '/producer/projects/new'
    | '/actor/projects/$projectId/record'
    | '/actor/projects/$projectId/script-review'
    | '/actor/projects/$projectId/upload'
    | '/producer/projects/$projectId/characters'
    | '/producer/projects/$projectId/financials'
    | '/producer/projects/$projectId/script-book'
    | '/producer/projects/$projectId/setup'
    | '/producer/projects/$projectId/takes'
    | '/supervisor/projects/$projectId/stems'
    | '/supervisor/projects/$projectId/takes'
    | '/actor/projects/$projectId'
    | '/producer/projects/$projectId'
    | '/supervisor/projects/$projectId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/accept-invite/$token'
    | '/account/data-export'
    | '/account/devices'
    | '/account/earnings'
    | '/account/notifications'
    | '/account/payment'
    | '/account/profile'
    | '/account/security'
    | '/account/tax'
    | '/admin/archival'
    | '/admin/audit-log'
    | '/admin/client-errors'
    | '/admin/failed-jobs'
    | '/admin/feature-flags'
    | '/admin/health'
    | '/admin/orgs'
    | '/auth/callback'
    | '/account/'
    | '/actor/'
    | '/admin/'
    | '/producer/'
    | '/supervisor/'
    | '/producer/projects/new'
    | '/actor/projects/$projectId/record'
    | '/actor/projects/$projectId/script-review'
    | '/actor/projects/$projectId/upload'
    | '/producer/projects/$projectId/characters'
    | '/producer/projects/$projectId/financials'
    | '/producer/projects/$projectId/script-book'
    | '/producer/projects/$projectId/setup'
    | '/producer/projects/$projectId/takes'
    | '/supervisor/projects/$projectId/stems'
    | '/supervisor/projects/$projectId/takes'
    | '/actor/projects/$projectId/'
    | '/producer/projects/$projectId/'
    | '/supervisor/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  AcceptInviteTokenRoute: typeof AcceptInviteTokenRoute
  AccountDataExportRoute: typeof AccountDataExportRoute
  AccountDevicesRoute: typeof AccountDevicesRoute
  AccountEarningsRoute: typeof AccountEarningsRoute
  AccountNotificationsRoute: typeof AccountNotificationsRoute
  AccountPaymentRoute: typeof AccountPaymentRoute
  AccountProfileRoute: typeof AccountProfileRoute
  AccountSecurityRoute: typeof AccountSecurityRoute
  AccountTaxRoute: typeof AccountTaxRoute
  AdminArchivalRoute: typeof AdminArchivalRoute
  AdminAuditLogRoute: typeof AdminAuditLogRoute
  AdminClientErrorsRoute: typeof AdminClientErrorsRoute
  AdminFailedJobsRoute: typeof AdminFailedJobsRoute
  AdminFeatureFlagsRoute: typeof AdminFeatureFlagsRoute
  AdminHealthRoute: typeof AdminHealthRoute
  AdminOrgsRoute: typeof AdminOrgsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AccountIndexRoute: typeof AccountIndexRoute
  ActorIndexRoute: typeof ActorIndexRoute
  AdminIndexRoute: typeof AdminIndexRoute
  ProducerIndexRoute: typeof ProducerIndexRoute
  SupervisorIndexRoute: typeof SupervisorIndexRoute
  ProducerProjectsNewRoute: typeof ProducerProjectsNewRoute
  ActorProjectsProjectIdRecordRoute: typeof ActorProjectsProjectIdRecordRoute
  ActorProjectsProjectIdScriptReviewRoute: typeof ActorProjectsProjectIdScriptReviewRoute
  ActorProjectsProjectIdUploadRoute: typeof ActorProjectsProjectIdUploadRoute
  ProducerProjectsProjectIdCharactersRoute: typeof ProducerProjectsProjectIdCharactersRoute
  ProducerProjectsProjectIdFinancialsRoute: typeof ProducerProjectsProjectIdFinancialsRoute
  ProducerProjectsProjectIdScriptBookRoute: typeof ProducerProjectsProjectIdScriptBookRoute
  ProducerProjectsProjectIdSetupRoute: typeof ProducerProjectsProjectIdSetupRoute
  ProducerProjectsProjectIdTakesRoute: typeof ProducerProjectsProjectIdTakesRoute
  SupervisorProjectsProjectIdStemsRoute: typeof SupervisorProjectsProjectIdStemsRoute
  SupervisorProjectsProjectIdTakesRoute: typeof SupervisorProjectsProjectIdTakesRoute
  ActorProjectsProjectIdIndexRoute: typeof ActorProjectsProjectIdIndexRoute
  ProducerProjectsProjectIdIndexRoute: typeof ProducerProjectsProjectIdIndexRoute
  SupervisorProjectsProjectIdIndexRoute: typeof SupervisorProjectsProjectIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supervisor/': {
      id: '/supervisor/'
      path: '/supervisor'
      fullPath: '/supervisor/'
      preLoaderRoute: typeof SupervisorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/producer/': {
      id: '/producer/'
      path: '/producer'
      fullPath: '/producer/'
      preLoaderRoute: typeof ProducerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/actor/': {
      id: '/actor/'
      path: '/actor'
      fullPath: '/actor/'
      preLoaderRoute: typeof ActorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/': {
      id: '/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/orgs': {
      id: '/admin/orgs'
      path: '/admin/orgs'
      fullPath: '/admin/orgs'
      preLoaderRoute: typeof AdminOrgsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/admin/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/admin/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/failed-jobs': {
      id: '/admin/failed-jobs'
      path: '/admin/failed-jobs'
      fullPath: '/admin/failed-jobs'
      preLoaderRoute: typeof AdminFailedJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/client-errors': {
      id: '/admin/client-errors'
      path: '/admin/client-errors'
      fullPath: '/admin/client-errors'
      preLoaderRoute: typeof AdminClientErrorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit-log': {
      id: '/admin/audit-log'
      path: '/admin/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminAuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/archival': {
      id: '/admin/archival'
      path: '/admin/archival'
      fullPath: '/admin/archival'
      preLoaderRoute: typeof AdminArchivalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/tax': {
      id: '/account/tax'
      path: '/account/tax'
      fullPath: '/account/tax'
      preLoaderRoute: typeof AccountTaxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/security': {
      id: '/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AccountSecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/profile': {
      id: '/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AccountProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/payment': {
      id: '/account/payment'
      path: '/account/payment'
      fullPath: '/account/payment'
      preLoaderRoute: typeof AccountPaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/notifications': {
      id: '/account/notifications'
      path: '/account/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AccountNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/earnings': {
      id: '/account/earnings'
      path: '/account/earnings'
      fullPath: '/account/earnings'
      preLoaderRoute: typeof AccountEarningsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/devices': {
      id: '/account/devices'
      path: '/account/devices'
      fullPath: '/account/devices'
      preLoaderRoute: typeof AccountDevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/data-export': {
      id: '/account/data-export'
      path: '/account/data-export'
      fullPath: '/account/data-export'
      preLoaderRoute: typeof AccountDataExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite/$token': {
      id: '/accept-invite/$token'
      path: '/accept-invite/$token'
      fullPath: '/accept-invite/$token'
      preLoaderRoute: typeof AcceptInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/producer/projects/new': {
      id: '/producer/projects/new'
      path: '/producer/projects/new'
      fullPath: '/producer/projects/new'
      preLoaderRoute: typeof ProducerProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supervisor/projects/$projectId/': {
      id: '/supervisor/projects/$projectId/'
      path: '/supervisor/projects/$projectId'
      fullPath: '/supervisor/projects/$projectId/'
      preLoaderRoute: typeof SupervisorProjectsProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/producer/projects/$projectId/': {
      id: '/producer/projects/$projectId/'
      path: '/producer/projects/$projectId'
      fullPath: '/producer/projects/$projectId/'
      preLoaderRoute: typeof ProducerProjectsProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/actor/projects/$projectId/': {
      id: '/actor/projects/$projectId/'
      path: '/actor/projects/$projectId'
      fullPath: '/actor/projects/$projectId/'
      preLoaderRoute: typeof ActorProjectsProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supervisor/projects/$projectId/takes': {
      id: '/supervisor/projects/$projectId/takes'
      path: '/supervisor/projects/$projectId/takes'
      fullPath: '/supervisor/projects/$projectId/takes'
      preLoaderRoute: typeof SupervisorProjectsProjectIdTakesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supervisor/projects/$projectId/stems': {
      id: '/supervisor/projects/$projectId/stems'
      path: '/supervisor/projects/$projectId/stems'
      fullPath: '/supervisor/projects/$projectId/stems'
      preLoaderRoute: typeof SupervisorProjectsProjectIdStemsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/producer/projects/$projectId/takes': {
      id: '/producer/projects/$projectId/takes'
      path: '/producer/projects/$projectId/takes'
      fullPath: '/producer/projects/$projectId/takes'
      preLoaderRoute: typeof ProducerProjectsProjectIdTakesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/producer/projects/$projectId/setup': {
      id: '/producer/projects/$projectId/setup'
      path: '/producer/projects/$projectId/setup'
      fullPath: '/producer/projects/$projectId/setup'
      preLoaderRoute: typeof ProducerProjectsProjectIdSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/producer/projects/$projectId/script-book': {
      id: '/producer/projects/$projectId/script-book'
      path: '/producer/projects/$projectId/script-book'
      fullPath: '/producer/projects/$projectId/script-book'
      preLoaderRoute: typeof ProducerProjectsProjectIdScriptBookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/producer/projects/$projectId/financials': {
      id: '/producer/projects/$projectId/financials'
      path: '/producer/projects/$projectId/financials'
      fullPath: '/producer/projects/$projectId/financials'
      preLoaderRoute: typeof ProducerProjectsProjectIdFinancialsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/producer/projects/$projectId/characters': {
      id: '/producer/projects/$projectId/characters'
      path: '/producer/projects/$projectId/characters'
      fullPath: '/producer/projects/$projectId/characters'
      preLoaderRoute: typeof ProducerProjectsProjectIdCharactersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/actor/projects/$projectId/upload': {
      id: '/actor/projects/$projectId/upload'
      path: '/actor/projects/$projectId/upload'
      fullPath: '/actor/projects/$projectId/upload'
      preLoaderRoute: typeof ActorProjectsProjectIdUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/actor/projects/$projectId/script-review': {
      id: '/actor/projects/$projectId/script-review'
      path: '/actor/projects/$projectId/script-review'
      fullPath: '/actor/projects/$projectId/script-review'
      preLoaderRoute: typeof ActorProjectsProjectIdScriptReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/actor/projects/$projectId/record': {
      id: '/actor/projects/$projectId/record'
      path: '/actor/projects/$projectId/record'
      fullPath: '/actor/projects/$projectId/record'
      preLoaderRoute: typeof ActorProjectsProjectIdRecordRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  AcceptInviteTokenRoute: AcceptInviteTokenRoute,
  AccountDataExportRoute: AccountDataExportRoute,
  AccountDevicesRoute: AccountDevicesRoute,
  AccountEarningsRoute: AccountEarningsRoute,
  AccountNotificationsRoute: AccountNotificationsRoute,
  AccountPaymentRoute: AccountPaymentRoute,
  AccountProfileRoute: AccountProfileRoute,
  AccountSecurityRoute: AccountSecurityRoute,
  AccountTaxRoute: AccountTaxRoute,
  AdminArchivalRoute: AdminArchivalRoute,
  AdminAuditLogRoute: AdminAuditLogRoute,
  AdminClientErrorsRoute: AdminClientErrorsRoute,
  AdminFailedJobsRoute: AdminFailedJobsRoute,
  AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,
  AdminHealthRoute: AdminHealthRoute,
  AdminOrgsRoute: AdminOrgsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AccountIndexRoute: AccountIndexRoute,
  ActorIndexRoute: ActorIndexRoute,
  AdminIndexRoute: AdminIndexRoute,
  ProducerIndexRoute: ProducerIndexRoute,
  SupervisorIndexRoute: SupervisorIndexRoute,
  ProducerProjectsNewRoute: ProducerProjectsNewRoute,
  ActorProjectsProjectIdRecordRoute: ActorProjectsProjectIdRecordRoute,
  ActorProjectsProjectIdScriptReviewRoute:
    ActorProjectsProjectIdScriptReviewRoute,
  ActorProjectsProjectIdUploadRoute: ActorProjectsProjectIdUploadRoute,
  ProducerProjectsProjectIdCharactersRoute:
    ProducerProjectsProjectIdCharactersRoute,
  ProducerProjectsProjectIdFinancialsRoute:
    ProducerProjectsProjectIdFinancialsRoute,
  ProducerProjectsProjectIdScriptBookRoute:
    ProducerProjectsProjectIdScriptBookRoute,
  ProducerProjectsProjectIdSetupRoute: ProducerProjectsProjectIdSetupRoute,
  ProducerProjectsProjectIdTakesRoute: ProducerProjectsProjectIdTakesRoute,
  SupervisorProjectsProjectIdStemsRoute: SupervisorProjectsProjectIdStemsRoute,
  SupervisorProjectsProjectIdTakesRoute: SupervisorProjectsProjectIdTakesRoute,
  ActorProjectsProjectIdIndexRoute: ActorProjectsProjectIdIndexRoute,
  ProducerProjectsProjectIdIndexRoute: ProducerProjectsProjectIdIndexRoute,
  SupervisorProjectsProjectIdIndexRoute: SupervisorProjectsProjectIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
